import React from 'react';
import { BsSearch } from 'react-icons/bs';

interface SearchBarProps {
    query: string;
    setQuery: (query: string) => void;
    placeholder?: string;
}

export const SearchBar = ({ query, setQuery, placeholder }: SearchBarProps) => {
    return (
        <div className='search-bar'>
            <BsSearch style={{ marginRight: '0.5rem' }} />
            <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder={placeholder || 'Search...'}
                style={{
                    border: 'none',
                    outline: 'none',
                    fontSize: '1rem',
                    width: '100%',
                    backgroundColor: 'transparent',
                }}
            />
        </div>
    );
};
